import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader
  // DialogTitle
} from '@/components/ui/dialog'
import { ReactNode } from 'react'

interface ModalProps {
  // title: string
  open: boolean
  onOpenChange: (open: boolean) => void
  children: ReactNode
  className?: string
}

export function DialogModal ({ open, onOpenChange, children, className = '' }: ModalProps): JSX.Element {
  return (
    <div className={`w-full md:min-w-[600px] lg:min-w-[700px] absolute ${className}`}>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className={`w-full md:min-w-[600px] lg:min-w-[900px] ${className}`}>
          <DialogHeader className='p-4'>
            {/* <DialogTitle className='mb-4'><TextTitle className='text-center'>{title}</TextTitle></DialogTitle> */}
            <DialogDescription>
              {children}
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </div>
  )
}
